import contract from '@/api/wholesale/sale-contract'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  products: [],
  customers: [],
  quotations: [],
  dateRange: [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')]
}

export const getters = {
  getProduct: state => ({ chosenProduct, search = '' } = {}) => {
    if(chosenProduct !== undefined){
      return state.products.filter(p => 
        !_.includes(chosenProduct.map(el => el.product_id),p.product_id)
      )
      .filter(p => 
        search.split(' ').every((s) => p.product_name_en.toLowerCase().includes(s.toLowerCase()))  ||
        search.split(' ').every((s) => p.barcode.toLowerCase().includes(s.toLowerCase())) 
      )
      .slice(0, 100);
    }
    return state.products.slice(0, 100);
  },
  getUom: state => productId => {
    let prod =  state.products.find(p => p.product_id == productId)
      return prod.uom_category.unit_of_measures
  },
  isDefaultUom: state => productId => {
    if(productId){
      let product = state.products.find(p => p.product_id == productId)
      var uom = product.uom_category.unit_of_measures.find(u => u.is_default == true)
      return uom.uom_id
    }
    return null
  },
  getSalePrice: state => ({ product_id, uom_id = null }) => {
    if(product_id && uom_id){
      let pro = state.products.find(p => p.product_id == product_id)
      var uom = pro.uom_category.unit_of_measures.find(u => uom_id ? u.uom_id == uom_id : u.is_default == true )
      var salecode =   pro.sale_code.find(
        s => s.uom_id == uom.uom_id
      )
      return salecode.product_price.sale_price ? salecode.product_price.sale_price : 0
    }
    return 0
  },
  findProduct: state => productId => {
    if(!productId) {
      return {
        barcode: null,
        product_name_en: null
      }
    }
    return state.products.find(p => p.product_id == productId)
  },
}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date){
    state.dateRange = date
  },
  SET_PRODUCT(state, data){
    state.products = data
  },
  SET_CUSTOMER(state, data){
    state.customers = data
  },
  SET_QUOTATION(state, data){
    state.quotations = data
  },
  CLEAR_SETUP(state){
    state.products = []
    state.customers = []
    state.quotations = []
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return contract.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return contract.store(data)
  },
  update(context, { id, data }) {
    return contract.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await contract.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, {id, data}){
    return contract.destroy(id, data)
  },
  previewPdf(context, id){
    return contract.toPdf(id)
  },
  async fetchResource(context){
    let var_product = await contract.product()
      context.commit('SET_PRODUCT', var_product.data)
    let var_customer = await contract.customer({
      params: { filter: { cus_type_id: 2 } }
    })
      context.commit('SET_CUSTOMER', var_customer.data)
  },
  async fetchQuotation(context){
    let var_quotation = await contract.quotation()
      context.commit('SET_QUOTATION', var_quotation.data)
  }
}
